// frontend/src/components/layout/Header.js
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaUser, FaShoppingCart, FaSignOutAlt, FaUserShield, FaChevronDown, FaTags, FaBoxes, FaShoppingBag, FaChartBar, FaInfoCircle, FaUsers, FaWarehouse, FaChartLine } from 'react-icons/fa';

import { logout } from '../../actions/authActions';

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { cartItems } = useSelector((state) => state.cart);

  const [showAdminMenu, setShowAdminMenu] = useState(false);
  const [showAboutMenu, setShowAboutMenu] = useState(false);
  
  const logoutHandler = () => {
    dispatch(logout());
    navigate('/login');
  };
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Calculate cart items count
  const cartItemCount = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  
  return (
    <header className="bg-red-800 text-white">
      {/* Top bar */}
      <div className="container mx-auto px-4 py-2 flex justify-between items-center">
        <div>
          <p className="text-xs md:text-sm">南昌市玉洒贸易有限公司 | 五粮液官方授权店</p>
        </div>
        <div className="flex items-center">
          {isAuthenticated ? (
            <div className="flex items-center">
              <Link to="/profile" className="text-xs md:text-sm hover:text-gray-300 flex items-center mr-4">
                <FaUser className="mr-1" />
                <span className="hidden md:inline">{user?.full_name || '我的账号'}</span>
                <span className="md:hidden">账号</span>
              </Link>
              {user?.is_admin && (
                <div className="relative">
                  <button 
                    onClick={() => setShowAdminMenu(!showAdminMenu)}
                    className="text-xs md:text-sm hover:text-gray-300 flex items-center mr-4"
                  >
                    <FaUserShield className="mr-1" />
                    <span className="hidden md:inline">管理</span>
                    <FaChevronDown className="ml-1" size={10} />
                  </button>
                  
                  {showAdminMenu && (
                    <div 
                      className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10"
                      onMouseLeave={() => setShowAdminMenu(false)}
                    >
                      <Link 
                        to="/admin" 
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                        onClick={() => setShowAdminMenu(false)}
                      >
                        <FaChartBar className="mr-2 text-gray-500" />
                        控制面板
                      </Link>
                      {/* 添加分析页面链接 */}
                      <Link 
                        to="/admin/analytics" 
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                        onClick={() => setShowAdminMenu(false)}
                      >
                        <FaChartLine className="mr-2 text-gray-500" />
                        销售分析
                      </Link>
                      <Link 
                        to="/admin/products" 
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                        onClick={() => setShowAdminMenu(false)}
                      >
                        <FaBoxes className="mr-2 text-gray-500" />
                        产品管理
                      </Link>
                      <Link 
                        to="/admin/inventory" 
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                        onClick={() => setShowAdminMenu(false)}
                      >
                        <FaWarehouse className="mr-2 text-gray-500" />
                        库存管理
                      </Link>
                      <Link 
                        to="/admin/categories" 
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                        onClick={() => setShowAdminMenu(false)}
                      >
                        <FaTags className="mr-2 text-gray-500" />
                        分类管理
                      </Link>
                      <Link 
                        to="/admin/orders" 
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                        onClick={() => setShowAdminMenu(false)}
                      >
                        <FaShoppingBag className="mr-2 text-gray-500" />
                        订单管理
                      </Link>
                      <Link 
                        to="/admin/users" 
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                        onClick={() => setShowAdminMenu(false)}
                      >
                        <FaUsers className="mr-2 text-gray-500" />
                        用户管理
                      </Link>
                    </div>
                  )}
                </div>
              )}
              <button
                onClick={logoutHandler}
                className="text-xs md:text-sm hover:text-gray-300 flex items-center"
              >
                <FaSignOutAlt className="mr-1" />
                <span className="hidden md:inline">退出</span>
              </button>
            </div>
          ) : (
            <Link to="/login" className="text-xs md:text-sm hover:text-gray-300">
              <span>登录 / 注册</span>
            </Link>
          )}
        </div>
      </div>

      {/* Main header - 桌面端 + 移动端优化 */}
      <div className="container mx-auto px-4 py-3 md:py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img 
              src="/images/logo_banner.png" 
              alt="南昌市玉洒贸易有限公司" 
              className="h-10 md:h-16"
            />
          </Link>

          {/* 移动端菜单按钮 */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-white"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          {/* 桌面端导航 */}
          <div className="hidden md:flex items-center">
            <nav className="mr-6">
              <ul className="flex space-x-6">
                <li>
                  <Link to="/" className="hover:text-gray-300">首页</Link>
                </li>
                <li>
                  <Link to="/products" className="hover:text-gray-300">产品</Link>
                </li>
                <li className="relative group">
                  <div 
                    className="flex items-center cursor-pointer hover:text-gray-300"
                    onClick={() => setShowAboutMenu(!showAboutMenu)}
                  >
                    <span>关于我们</span>
                    <FaChevronDown className="ml-1" size={10} />
                  </div>
                  <div 
                    className={`absolute top-full left-0 mt-2 w-40 bg-white text-gray-800 rounded-md shadow-lg py-1 z-10 transition-all duration-300 ${showAboutMenu ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                    onMouseLeave={() => setShowAboutMenu(false)}
                  >
                    <Link 
                      to="/about" 
                      className="block px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
                      onClick={() => setShowAboutMenu(false)}
                    >
                      <FaInfoCircle className="mr-2 text-gray-500" />
                      公司简介
                    </Link>
                    <Link 
                      to="/team" 
                      className="block px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
                      onClick={() => setShowAboutMenu(false)}
                    >
                      <FaUsers className="mr-2 text-gray-500" />
                      管理团队
                    </Link>
                  </div>
                </li>
              </ul>
            </nav>

            <Link to="/cart" className="relative p-2">
              <FaShoppingCart size={24} />
              {cartItemCount > 0 && (
                <span className="absolute top-0 right-0 bg-yellow-500 text-xs text-black w-5 h-5 flex items-center justify-center rounded-full">
                  {cartItemCount}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* 移动端下拉菜单 */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-red-700">
            <nav className="mt-4 space-y-2">
              <Link 
                to="/" 
                className="block py-2 text-white hover:text-gray-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                首页
              </Link>
              <Link 
                to="/products" 
                className="block py-2 text-white hover:text-gray-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                产品
              </Link>
              {/* 关于我们移动端二级菜单 */}
              <div>
                <button 
                  className="w-full text-left py-2 text-white hover:text-gray-300 flex items-center"
                  onClick={() => setShowAboutMenu(!showAboutMenu)}
                >
                  关于我们
                  <FaChevronDown className="ml-1" size={10} />
                </button>
                {showAboutMenu && (
                  <div className="ml-4 mt-1 space-y-1">
                    <Link 
                      to="/about"
                      className="block py-1 text-white hover:text-gray-300 text-sm"
                      onClick={() => { setShowAboutMenu(false); setMobileMenuOpen(false); }}
                    >
                      公司简介
                    </Link>
                    <Link 
                      to="/team"
                      className="block py-1 text-white hover:text-gray-300 text-sm"
                      onClick={() => { setShowAboutMenu(false); setMobileMenuOpen(false); }}
                    >
                      管理团队
                    </Link>
                  </div>
                )}
              </div>
              <Link 
                to="/cart" 
                className="block py-2 text-white hover:text-gray-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                购物车 ({cartItemCount})
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;